/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import DashboardHome from './home'
import DashboardNavigator from './navigator'
import DashboardView from './view/layout'
import DashboardExport from './export'

/*  
    TODO:
    Currently we use different routes under /dashboard to navigate through different parts of 
    the dashboard because we use multiple iframes in dashboard. I imagine when we want to build the
    entire dashboard w/o using Closure communicating between parts, we'll have to assemble
    those parts(main, display, navigation...etc) in here.
*/

const Dashboard = () => {
  return (
    <Routes>
      <Route path="home" element={<DashboardHome />} />
      <Route path="navigator" element={<DashboardNavigator />} />
      <Route path="export/:dashboardId" element={<DashboardExport />} />
      <Route path=":dashboardId" element={<DashboardView />} />
    </Routes>
  )
}
export default Dashboard
